import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _user, _Config } from "@discovery/common-dplus/lib/state";
import { _HamburgerFooterList, _HamburgerHeader, _HamburgerList, } from "./optics";
import { DrawerView } from "./view";
import { useUser } from "../../utils/hooks";
const getProps = (data) => {
    const headerData = Fold.toArray(_HamburgerHeader, data);
    const hamburgerList = Fold.toArray(_HamburgerList, data);
    const hamburgerFooterList = Fold.toArray(_HamburgerFooterList, data);
    return {
        headerData,
        hamburgerList,
        hamburgerFooterList,
    };
};
const Hamburger = ({ headerData, hamburgerList, hamburgerFooterList, environment, }) => {
    const [userM] = useGlobalState(_user);
    const [configM] = useGlobalState(_Config);
    const { isAnonymous } = useUser();
    const frameworkConfigurationsM = M.chain((x) => x.frameworkConfigurations, configM);
    const blueshiftM = M.chain((x) => x.blueshift, frameworkConfigurationsM);
    const environmentKeyM = M.chain((x) => x.environmentKey, blueshiftM);
    const environmentKey = M.fromMaybe(environmentKeyM, "1295b960cb09c5dfcf9c113dee41115f");
    window._blueshiftid = environmentKey;
    if (isAnonymous) {
        sessionStorage.removeItem("pA");
        localStorage.removeItem("isSuccessPa");
    }
    const webAuthUrl = environment.authService.protocol + "://" + environment.authService.domain;
    const parentalLockM = M.chain((x) => x.parentalLock, configM);
    const minimumAgeM = M.chain((x) => x.minimumAge, parentalLockM);
    const ageConstraint = M.fromMaybe(minimumAgeM, 0);
    const version = environment.sonicApiAppConfig.version;
    return (React.createElement(DrawerView, { headerData: headerData, hamburgerList: hamburgerList, hamburgerFooterList: hamburgerFooterList, read: environment, ageConstraint: ageConstraint, userM: userM, webAuthRedirectionUrl: webAuthUrl, environment: version }));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, Hamburger);

